import React, { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { toPhoneNumber } from '@common/utils/index';
import { showModal } from '@store/actions/commonAction';

import { kakaoCertiRequest } from '@store/actions/userAction';

const LoginKakaoCertificate = () => {
  const input1Ref = useRef();

  const dispatch = useDispatch();

  const [certificateInfo, setCertificateInfo] = useState({
    username: '',
    birthDate: '',
    cpNo: '',
  });

  const [isFocused, setIsFocused] = useState([
    { name: 'username', focused: false },
    { name: 'birthDate', focused: false },
    { name: 'cpNo', focused: false },
  ]);
  const [isOpenAgree1, setIsOpenAgree1] = useState(false);
  const [isOpenAgree2, setIsOpenAgree2] = useState(false);

  const [agreeCheck, setAgreeCheck] = useState([
    { id: 'agreeChk1', checked: false },
    // { id : 'agreeChk2', checked : false }
  ]);

  const [allAgreeChk, setAllAgreeChk] = useState(false);

  useEffect(() => {
    input1Ref.current.focus();
  }, []);

  useEffect(() => {
    if (
      agreeCheck.filter(item => {
        return item.checked === true;
      }).length === 1
    ) {
      setAllAgreeChk(true);
    }
  }, [agreeCheck]);

  const onInputChangeHandler = e => {
    const { name, value } = e.target;

    /**
     * name에 따른 값 포맷 변경
     * @returns {String} value
     */
    const convert = () => {
      switch (name) {
        case 'birthDate':
          return value.replace(/[^0-9]/gi, '');
        case 'cpNo':
          return toPhoneNumber(value.replace(/[^0-9]/gi, ''));
        default:
          return value;
      }
    };

    setCertificateInfo({
      ...certificateInfo,
      [name]: convert(),
    });
  };

  const onInputFocusHandler = e => {
    const { name } = e.target;

    setIsFocused(
      isFocused.map(item => {
        return name === item.name ? { ...item, focused: true } : item;
      }),
    );
  };

  const onInputBlurHandler = e => {
    const { name } = e.target;

    setIsFocused(
      isFocused.map(item => {
        return name === item.name ? { ...item, focused: false } : item;
      }),
    );
  };

  const onCertificateButtonClick = () => {
    const validation = () => {
      const { username, birthDate, cpNo } = certificateInfo;

      if (
        username.trim() === '' ||
        birthDate.trim() === '' ||
        cpNo.trim() === ''
      ) {
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: '입력 정보가 없는 항목이 있습니다.\n입력 정보를 다시 확인해주세요.',
          }),
        );
        return false;
      }

      if (!allAgreeChk) {
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: '약관을 동의해주세요.',
          }),
        );
        return false;
      }

      return true;
    };

    if (validation()) {
      dispatch(kakaoCertiRequest(certificateInfo));
    }
  };

  const onAgreeClick = type => {
    if (type === 'agree1') {
      setIsOpenAgree1(true);
    } else if (type === 'agree2') {
      setIsOpenAgree2(true);
    }
  };

  const onAgreeConfirm = type => {
    if (type === 'agree1') {
      setAgreeCheck([...agreeCheck, { id: 'agreeChk1', checked: true }]);
    } else if (type === 'agree2') {
      setAgreeCheck([...agreeCheck, { id: 'agreeChk1', checked: true }]);
    }
    // else if(type === 'agree2'){
    //     setAgreeCheck([
    //         ...agreeCheck,
    //         { id : 'agreeChk2', checked : true }
    //     ])
    // }
  };

  const onAllCheckHandler = ({ target }) => {
    if (target.checked) {
      setAgreeCheck([
        { id: 'agreeChk1', checked: true },
        // { id : 'agreeChk2', checked : true }
      ]);
      setAllAgreeChk(true);
    } else {
      setAgreeCheck([
        { id: 'agreeChk1', checked: false },
        // { id : 'agreeChk2', checked : false }
      ]);
      setAllAgreeChk(false);
    }
  };

  const getCheckedId = id => {
    return agreeCheck.some(item => {
      return item.id === id && item.checked === true;
    });
  };

  const getFocusOrNot = inputName => {
    return isFocused.some(item => {
      return item.name === inputName && item.focused === true;
    });
  };

  return (
    <>
      {/* <div className='page-navi'>
                <button type='button' className='btn-back' onClick={() => history.goBack()}><span className='hide'>이전</span></button>
            </div>
            <h3 className='tit-con'>카카오페이 인증서1/2</h3> */}

      <div className="logincon-area">
        <div className="login-form">
          <div
            className={`input-wrap val ${
              getFocusOrNot('username') === true ? 'focus' : ''
            }`}
          >
            <div className="input-area">
              <label htmlFor="username" className="input-tit">
                이름
              </label>
              <input
                ref={input1Ref}
                id="username"
                name="username"
                className="input"
                placeholder="이름을 입력하세요."
                autoComplete="off"
                spellCheck={false}
                value={certificateInfo.username}
                onChange={onInputChangeHandler}
                onFocus={onInputFocusHandler}
                onBlur={onInputBlurHandler}
              />
            </div>
          </div>
          <div
            className={`input-wrap val ${
              certificateInfo.birthDate.length === 8 ||
              certificateInfo.birthDate.length === 0
                ? ''
                : 'error'
            } ${getFocusOrNot('birthDate') === true ? 'focus' : ''}`}
          >
            <div className="input-area">
              <label htmlFor="birthDate" className="input-tit">
                생년월일 8자리
              </label>
              <input
                id="birthDate"
                name="birthDate"
                maxLength="8"
                className="input"
                placeholder="생년월일 8자리를 입력하세요.(예:19910101)"
                autoComplete="off"
                spellCheck={false}
                value={certificateInfo.birthDate}
                onChange={onInputChangeHandler}
                onFocus={onInputFocusHandler}
                onBlur={onInputBlurHandler}
              />
            </div>
          </div>
          {certificateInfo.birthDate.length === 8 ||
          certificateInfo.birthDate.length === 0 ? (
            ''
          ) : (
            <p className="text-info ico-type error">
              생년월일은 8자리로 입력합니다.
            </p>
          )}
          <div
            className={`input-wrap val ${
              getFocusOrNot('cpNo') === true ? 'focus' : ''
            }`}
          >
            <div className="input-area">
              <label htmlFor="cpNo" className="input-tit">
                휴대전화번호
              </label>
              <input
                id="cpNo"
                name="cpNo"
                className="input"
                placeholder="숫자만 입력하세요."
                autoComplete="off"
                spellCheck={false}
                value={certificateInfo.cpNo}
                onChange={onInputChangeHandler}
                onFocus={onInputFocusHandler}
                onBlur={onInputBlurHandler}
              />
            </div>
          </div>

          <div className="agree-list mgb-0">
            <div className="tit-area">
              <div className="check-wrap default">
                <input
                  type="checkbox"
                  name="radioAll"
                  id="radioAll"
                  onChange={onAllCheckHandler}
                  checked={allAgreeChk}
                ></input>
                <label htmlFor="radioAll">전체동의</label>
              </div>
            </div>
            <ul className="agree-req-chk">
              <li
                className={`${
                  getCheckedId('agreeChk1') === true ? 'active' : ''
                }`}
              >
                <span>개인정보 이용 동의(필수)</span>
                <button
                  type="button"
                  className="btn-view-move"
                  //   onClick={() => onAgreeClick('agree1')}
                  onClick={() => onAgreeClick('agree2')}
                >
                  이동
                </button>
              </li>
              {/* <li className={`${getCheckedId('agreeChk2') === true ? 'active' : ''}`}>
                                <span>제3자정보제공동의(필수)</span>
                                <button type='button' className='btn-view-move' onClick={() => onAgreeClick('agree2')}>이동</button>
                            </li> */}
            </ul>
          </div>

          <div className="text-center">
            <p className="text-info2 ico-type">
              KB라이프생명에 등록된 정보를 입력해 주세요.
            </p>
          </div>
        </div>
      </div>

      <div className="btn-area">
        <button
          type="button"
          className="btn-l blue"
          onClick={onCertificateButtonClick}
        >
          인증요청
        </button>
      </div>
    </>
  );
};

export default LoginKakaoCertificate;
